import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: 'mat-icon[sgSwitchIconOnHover]',
  standalone: false,
})
export class SgSwitchIconOnHoverDirective implements AfterViewInit, OnChanges {
  @Input('sgSwitchIconOnHover') iconName: string;
  @Input('iconColor') iconColor: string;
  @Input() isDisabled: boolean;
  @Input() disabledColor: string;

  initialIconName: string;
  initialIconColor: string;

  constructor(private el: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('isDisabled' in changes) {
      if (changes.isDisabled.firstChange) return;
      if (changes.isDisabled.currentValue) {
        this.el.nativeElement.style.cursor = 'default';
        this.el.nativeElement.style.color = this.disabledColor;
        this.el.nativeElement.innerText = this.iconName;
      } else {
        this.el.nativeElement.style.cursor = 'pointer';
        this.el.nativeElement.innerText = this.initialIconName;
        this.el.nativeElement.style.color = this.initialIconColor;
      }
    }
  }

  ngAfterViewInit(): void {
    this.initialIconName = this.el.nativeElement.innerText;
    this.initialIconColor = this.el.nativeElement.style.color;

    if (this.isDisabled) {
      this.el.nativeElement.style.color = this.disabledColor;
      this.el.nativeElement.innerText = this.iconName;
    } else {
      this.el.nativeElement.style.cursor = 'pointer';
    }
  }

  @HostListener('mouseenter') onMouseEnter() {
    if (this.isDisabled) return;
    this.el.nativeElement.innerText = this.iconName;
    this.el.nativeElement.style.color = this.iconColor;
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.isDisabled) return;
    this.el.nativeElement.innerText = this.initialIconName;
    this.el.nativeElement.style.color = this.initialIconColor;
  }
}
